import notification from 'ant-design-vue/es/notification'
import {axios} from '.'
import config from '../config'
import {notificationConfig} from '../config/globalConfig'

notification.config(notificationConfig)
// console.log(axios)

const successResult = (res) => {
  let {code, result, desc} = res
  if (code === 0) {
    // console.log(result)
    // return Promise.resolve(result)
    return result
  } else {
    notification.error({message: desc})
  }
}

export const httpModel = {
  // 获取自定义的实体字段
  getCustomEntityTitles: () => {
    return axios.get(config.api.entity_title_url).then((res) => {
      // console.log(res)
      return Promise.resolve(successResult(res))
      // return successResult(res)
    })
  },
  // 根据ID获取实体信息
  getEntityInfoById: (id) => {
    return axios.get(config.api.entity_detail_url + '/' + id).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 重置密码
  resetPassword: (param) => {
    return axios.post(config.api.reset_password_by_user, param).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 短信是否共享
  setShareSms: (param) => {
    return axios.post(config.api.set_is_share_sms, param).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 获取机构围栏信息
  getOrgFenceById: (orgId) => {
    return axios.get(config.api.entity_group_url + '/' + orgId).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 获取实体的步数和心率
  getEntityCurrentHealth: (id) => {
    return axios.get(config.api.get_entity_current_health + id).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 刷新token
  refreshToken: (token) => {
    return axios.post(config.api.refresh_token, token).then((res) => {
      // return Promise.resolve(successResult(res))
      let {code, result} = res
      if (code === 0) {
        // console.log(result)
        // return Promise.resolve(result)
        return Promise.resolve(result)
      }
    })
  },
  // 获取机构的分组信息
  getOrgGroupsInfo: (orgId) => {
    return axios.get(config.api.get_org_groups_info + orgId).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 获取设备制式
  getDeviceStandard: () => {
    return axios.get(config.api.get_device_standard).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 修改设备remark信息
  setDeviceRemark: (param) => {
    return axios.post(config.api.set_device_remark, param).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 获取设备类型信息
  getDeviceModelById: (deviceId) => {
    return axios.get(config.api.get_device_model_by_id + deviceId).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  // 设置告警相声
  setAlarmRingType: (type) => {
    return axios.post(config.api.set_alarm_notice_type + type).then((res) => {
      return Promise.resolve(successResult(res))
    })
  },
  statistics: (obj) => {
    return axios.post(config.api.statistics ,obj).then((res) => {
      return res
    })
  }
}

export default {
  httpModel
}